import { useEffect } from 'react';
import { getStoredUser, saveSession, clearSession } from '../../utils/format';

// On every visit, renew a logged-in customer's token (90 days from now) and refresh their
// stored details, so regular customers stay logged in and never have to log in again.
const SessionKeeper = () => {
    useEffect(() => {
        if (!getStoredUser()) return;
        // Loaded lazily so the API client isn't part of the very first download
        import('../../api/axiosConfig')
            .then(({ default: api }) => api.get('/auth/me'))
            .then(res => saveSession(res.data))
            .catch(err => {
                // Account removed or token rejected: log out quietly (offline = keep the session)
                if (err.response?.status === 401) clearSession();
            });
    }, []);
    return null;
};

export default SessionKeeper;
